import BaseReporter from './BaseReporter';
import { ReporterAction } from '../types';
import { PageLoadMetrics } from '../Metrics';
import { isReload } from '../navigation';

export default class PageReloadReporter extends BaseReporter {
  report(action: ReporterAction) {
    switch (action.type) {
      case 'ROUTE_STARTED': {
        if (isReload()) {
          PageLoadMetrics.counter('reloaded').increment();
        }

        break;
      }
      default:
    }
  }
}
